import { renderToString } from "react-dom/server";
import { cn } from "@utils/index";
import React from "react";

export type HighlighterProps = { highlightText?: string, minLength?: number, children: string } & React.ComponentPropsWithoutRef<"span">

export function Highlighter({ children, highlightText, minLength = 1, className, ...props }: HighlighterProps) {
  function rawChildren(c = children) {
    return <div {...props} className={cn(className)} dangerouslySetInnerHTML={{ __html: c }} />
  }
  if (!highlightText) return rawChildren()
  if (highlightText.length < minLength) return rawChildren()

  const sanitizedHighlightText = highlightText.replaceAll(/[.*+?^${}()|[\]\\]/g, "\\$&")

  const highlightRegex = new RegExp(sanitizedHighlightText, "gi");

  return rawChildren(children.replaceAll(highlightRegex, (match) => {
    const comp = <span className={cn("bg-yellow-700", className)} {...props}>{match}</span>
    return renderToString(comp)
  }))
}

